export const isSameDay = (date1: number, date2: number): boolean => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
};

export const startOfDay = (date: number = Date.now()): number => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};

// Helper to safely parse dates across browsers
export const parseSafeDate = (dateStr: string | Date | undefined): Date => {
  if (!dateStr) return new Date();

  if (dateStr instanceof Date) return dateStr;

  // Handle ISO date string
  if (typeof dateStr === 'string') {
    // Replace any spaces with 'T' for consistency
    const normalizedDate = dateStr.replace(' ', 'T');

    // If it's just a date without time, append time
    if (normalizedDate.length === 10) {
      return new Date(normalizedDate + 'T00:00:00Z');
    }

    // Parse with timezone if present, otherwise assume UTC
    return new Date(normalizedDate + (normalizedDate.includes('Z') ? '' : 'Z'));
  }

  return new Date();
};

/**
 * Format a date to a readable string
 */
export const formatDate = (date: Date | undefined): string => {
  if (!date) return 'TBC';
  const safeDate = parseSafeDate(date);
  // Always use en-US locale for consistency across the app
  return safeDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatDateShort = (date: Date | undefined) => {
  if (!date) return 'TBC';
  const safeDate = parseSafeDate(date);
  // Always use en-US locale for consistency across the app
  return safeDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
};

export const formatDateLong = (date: Date | undefined) => {
  if (!date) return 'TBC';
  const safeDate = parseSafeDate(date);
  // Always use en-US locale for consistency across the app
  return safeDate.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
};
